import { render, staticRenderFns } from "./AppSideMenu.vue?vue&type=template&id=30e119f2&scoped=true&"
import script from "./AppSideMenu.vue?vue&type=script&lang=ts&"
export * from "./AppSideMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e119f2",
  null
  
)

export default component.exports